import React from "react";


import axios from "axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { TwButton, TwMainLayout } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { loadingState, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import { getUrlForBookings, getUrlForUsers } from "../../utils/confighelpers";
import BZLogo from "../../components/BZLogo";
import FitClubLogo from "../../components/FitClubLogo";
import TenantLogo from "../../components/TenantLogo";
import { useToast } from "../../provider/ToastProvider";

export default function StripeCheckoutSessionsSuccessCancel({ navigation, landFor }) {

  const { addConfirmDialog, addNotificationDialog } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const [searchParams, setSearchParams] = useSearchParams();
  const [subscriptionPlan, setSubscriptionPlan] = React.useState([]);
  const initialTime = moment();

  const getUserInfo = async () => {
    dispatch(setGlobalLoading(true));
    const config = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axios(config);
    if (request.data.statusCode === 200) {
      console.log("data", request.data.data);
      const userData = request.data.data;

      /* if (userData.onBoardingStep === 0) {
      } else if (userData.onBoardingStep === 1) {
      } else if (userData.onBoardingStep === 2) {

      } else  */if (userData.onBoardingStep === 1) {
        navigation("/on-bording");
      } else if (userData.onBoardingStep === 3) {
        navigation("/businessprofilesetup/done");
      } else {
        var duration = moment.duration(moment(initialTime, 'YYYY-MM-DD h:mm A').diff(moment()));
        var minutes = duration.asMinutes();
        console.log("minutes", minutes);

        if (minutes <= 5) {
          var timer = setTimeout(async function () {
            await getUserInfo();
            // clearInterval(timer);
            // clearInterval(timeInterval);
          }, 5000);
        } else {
          dispatch(setGlobalLoading(false));
        }
      }
    }
  }

  const checkStripeSubscriptionCheckoutStatus = async () => {
    dispatch(setGlobalLoading(true));
    const config = {
      method: "post",
      url: `${getUrlForBookings()}payments/checkStripeSubscriptionCheckoutStatus`,
      data: {
        session_id: searchParams.get("session_id"),
        customer_id: searchParams.get("customer_id")
      },
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axios(config);
    if (request.data.statusCode === 200) {
      console.log("data", request.data.data);
      const checkoutStatusData = request.data.data;

      if (checkoutStatusData.checkoutSessionStatus === "trialing" || checkoutStatusData.checkoutSessionStatus === "active") {
        if (userReduxState.businessType === "service") {
          navigation("/myresource/add", {
            state: {
              ...location.state,
              ...userReduxState.userData,
              from: "registration",
              sentFromVerifyEmail: true,
            },
          })
        } else {
          navigation("/businessprofilesetup/done");
        }
      } /* else if (checkoutStatusData.checkoutSessionStatus === "active") {
        navigation("/businessprofilesetup/done");
      }  */else {
        var duration = moment.duration(moment(initialTime, 'YYYY-MM-DD h:mm A').diff(moment()));
        var minutes = duration.asMinutes();
        console.log("minutes", minutes);

        if (minutes <= 5) {
          var timer = setTimeout(async function () {
            await checkStripeSubscriptionCheckoutStatus();
            // clearInterval(timer);
            // clearInterval(timeInterval);
          }, 5000);
        } else {
          dispatch(setGlobalLoading(false));
        }
      }
    }
  }

  React.useEffect(() => {
    // dispatch(setGlobalLoading(true));
    // setTimeout(async function () {
    //   if (userReduxState.businessType === "event") {
    //     await getUserInfo();
    //   } else {
    //     await checkStripeSubscriptionCheckoutStatus();
    //   }
    // }, 2000);
    addNotificationDialog({
      dialogType: landFor == "success" ? "success" : "error",
      dialogTitle: landFor == "success" ? "Success" : "",
      dialogMessage: landFor == "success" ? "Your payment was successful. Thank you for your purchase!" : "Payment canceled or failed.",
      dialogBtnTitle: "Close",
      dialogBackdropClick: async () => { window.close(); },
      dialogBtnClick: async () => { window.close(); }
    })
  }, []);



  return (<></>)
  return (
    <TwMainLayout
      userType={"skip"}
      fullScreen={true} checkSession={false}>
      <div className="max-w-sm mx-auto flex min-h-full h-screen flex-1 flex-col justify-center items-center gap-4 px-6 py-12 lg:px-8">
        <div className="flex flex-col justify-center items-center gap-4 px-6 py-12 lg:px-8 border rounded-lg shadow-lg">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            {/* <FitClubLogo className="mx-auto [!w-3/4]" /> */}
            <TenantLogo className="mx-auto" />

          </div>
          <div className={"flex flex-col justify-center items-center gap-3 "}>
            {/* <h2 className="mt-5 text-center text-4xl md:text-4xl font-bold tracking-tight text-brown-coffee">
          </h2> */}
            <p className={"text-brown-coffee text-base md:text-lg text-center"}>
              {landFor == "success" ? "Your payment was successful. Thank you for your purchase!" : "Payment canceled or failed."}
            </p>

            {/* {!signupComplete && (<div className="hidden sm:flex justify-center sm:mx-auto sm:w-full sm:max-w-md mt-4">
              <div className="flex flex-col gap-2 justify-center items-center">
                Powered by
                <div className="flex gap-2 justify-center">
                  <FitClubLogo className="!w-auto sm:!w-auto md:!w-auto max-h-6" />
                  <span className="text-brown-coffee font-bold">
                    <span className="text-portland-orange">
                      Fit
                    </span>Club
                  </span>
                </div>
              </div>
            </div>)} */}
            {/* <div className="sm:hidden w-full border-b sm:border-b-0 border-gray-400 my-3"></div> */}
          </div>
          {loadingReduxState.globalLoading === false && (<TwButton
            variant={"orange"}
            onClick={() => {
              window.close();
            }}>
            Close
          </TwButton>)}
        </div>
      </div>
    </TwMainLayout>)

}
